















import Vue, { PropType } from 'vue'
import * as types from '@/store/modules/play/types'
import * as audioUtil from '@/utils/audio'
import * as localstorageUtil from '@/utils/localstorage'

interface State {
  isTouch: boolean;
}

export default Vue.extend({
  name: 'UserRecordedKey',

  props: {
    shortcutKey: Object as PropType<types.EffectShortcutKey>,
  },

  data (): State {
    return {
      isTouch: false,
    }
  },

  mounted () {
    // 録音済みの音が保存されているかチェックする
    this.checkSavedUserRecord()

    // 音にショートカットキーを割り当て
    window.addEventListener('keydown', this.onKeyDown)
    window.addEventListener('keyup', this.onKeyUp)
  },

  beforeDestroy () {
    window.removeEventListener('keydown', this.onKeyDown)
    window.removeEventListener('keyup', this.onKeyUp)
  },

  computed: {
    /**
     * 音のリソース（このキーに割り当てられている音）
     */
    source (): types.UserRecordedSoundSrc {
      return this.$store.state[types.moduleName].soundSources.userRecorded
    },

    /**
     * AudioContext
     */
    audioContext (): AudioContext {
      return this.$store.state[types.moduleName].audioContext
    },

    /**
     * 収録＆再生開始時のAudioContextの時間
     */
    audioContextStartAt (): number {
      return this.$store.state[types.moduleName].audioContextStartAt
    },

    /**
     * 再生モード
     */
    playMode (): types.PlayMode {
      return this.$store.state[types.moduleName].playMode
    },

    /**
     * 選択中のトラックインデックス
     */
    selectedTrackIndex (): number {
      return this.$store.state[types.moduleName].selectedTrackIndex
    },

    /**
     * 録音中か
     */
    isRecording (): boolean {
      return this.$store.state[types.moduleName].playMode === 'record'
    },

    /**
     * 収録前のカウントダウン中か
     */
    isCountingDown (): boolean {
      return this.$store.state[types.moduleName].isCountingDown
    },
  },

  methods: {
    /**
     * 音を再生
     */
    playAudio () {
      if (this.source && this.source.audioBuffer) {
        // AudioContextを生成しておく
        this.$store.commit(`${types.moduleName}/${types.Mutation.AUDIO_CONTEXT.CREATE}`)

        const audioBufferSourceNode = audioUtil.playAudio(this.audioContext, this.source.audioBuffer, 0)
        const playingBufferSourceId = audioUtil.createPlayingAudioBufferId()  // 再生中リストで管理するためのIDを発行する

        // IE11ではplayAudioの戻り値がnullになるので、if文で弾く
        if (audioBufferSourceNode) {
          // 再生中リストに追加する
          const payload: types.PlayingBufferSource = {
            id: playingBufferSourceId,
            soundId: this.source.soundId,
            audioBufferSourceNode: audioBufferSourceNode,
          }
          this.$store.commit(`${types.moduleName}/${types.Mutation.PLAYING_BUFFER_SOURCE.ADD}`, payload)

          // 音の再生終了で再生中リストから削除
          audioBufferSourceNode.addEventListener('ended', () => {
            this.$store.commit(`${types.moduleName}/${types.Mutation.PLAYING_BUFFER_SOURCE.REMOVE}`, playingBufferSourceId)
          })

          // 収録モードかつカウントダウン後ならスコアに追加する
          if (this.isRecording && !this.isCountingDown) {
            this.$store.commit(`${types.moduleName}/${types.Mutation.SCORE.ADD_SOUND}`, {
              id: audioUtil.createSoundOnScoreId(), // ユニークなIDを生成
              soundId: this.source.soundId,
              trackIndex: this.selectedTrackIndex,
              when: this.audioContext.currentTime - this.audioContextStartAt,
            })
          }
        }
      } else {
        // ここにくるのは実装エラーのはず
        console.error('SoundSource or AudioBuffer not assigned.', this.source)
      }
    },

    /**
     * 保存済みの音を処理
     */
    checkSavedUserRecord () {
      const loadedArrayBuffer = localstorageUtil.load()

      if (loadedArrayBuffer) {
        console.log('保存されていた')
        this.findSaved(loadedArrayBuffer)
      } else {
        console.log('保存されていない')
      }
    },

    /**
     * 保存済みの音あり
     * @param arrayBuffer
     */
    findSaved (arrayBuffer: ArrayBuffer) {
      console.log('saved', arrayBuffer)

      // AudioContextを生成しておく
      this.$store.commit(`${types.moduleName}/${types.Mutation.AUDIO_CONTEXT.CREATE}`)

      // SafariはPromiseベースのデコードをサポートしていない
      this.audioContext.decodeAudioData(arrayBuffer,
        (decodedData: AudioBuffer) => {
          console.log(decodedData)

          // storeに反映
          this.$store.commit(`${types.moduleName}/${types.Mutation.USER_SOUND.SET}`, decodedData)
        },
        (e: Error) => {
          console.log(e)
        })
    },

    /**
     * 触った
     */
    touchstart () {
      // 音を鳴らす
      this.playAudio()

      this.isTouch = true
    },

    /**
     * 放した
     */
    touchend () {
      this.isTouch = false
    },

    /**
     * キーが押された
     */
    onKeyDown (e: KeyboardEvent) {
      // 該当のショートカットキーが押された
      // 押しっぱなしでもイベントが発生するため、isTouchで押下したときのみ処理する
      if (e.code === this.shortcutKey.code && !e.metaKey && !e.shiftKey && !this.isTouch) {
        this.isTouch = true
        this.playAudio()
      }
    },

    /**
     * キーが離された
     * @param e
     */
    onKeyUp (e: KeyboardEvent) {
      // 該当のショートカットキーが押された
      if (e.code === this.shortcutKey.code) {
        this.isTouch = false
      }
    },
  },
})
